import { Device } from 'Capacitor/@capacitor/device'

export async function computeLocale() {
  const languageCode = (await Device.getLanguageCode()).value
  if (languageCode.startsWith('fr')) {
    return {
      locale: 'fr',
      i18n: 'fr-FR'
    }
  } else if (languageCode.startsWith('en')) {
    return {
      locale: 'en',
      i18n: 'en-US'
    }
  } else {
    return {
      locale: 'fr',
      i18n: 'fr-FR'
    }
  }
}
